import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import { chooseCardsData } from 'sections/Services/TradeFinance/data';
import { ChooseCardType } from 'sections/Services/TradeFinance/types';
import styles from 'sections/Services/TradeFinance/components/SectionChoose/SectionChoose.module.scss';

const cn = classNames.bind(styles);

const SectionChoose = (): ReactElement => {
  const chooseCards = chooseCardsData.map((card: ChooseCardType) => {
    return (
      <SwiperSlide key={card.id}>
        <div className={cn('swiper__slide')}>
          <img
            className={cn('swiper__slide-icon')}
            src={`/images/pages/Services/TradeFinance/${card.iconName}.svg`}
            alt={card.iconName}
          />
          <h4 className={cn('swiper__slide-heading')}>
            {card.heading}
          </h4>
          <p className={cn('swiper__slide-description')}>
            {card.description}
          </p>
        </div>
      </SwiperSlide>
    );
  });

  return (
    <section className={cn('choose')}>
      <div className={cn('container')}>

        <h2 className={cn('choose__heading')}>
          Why choose us?
        </h2>

        <div className={cn('choose__swiper-container')}>
          <Swiper
            className={cn('swiper')}
            modules={[Pagination, Autoplay]}
            slidesPerView={1}
            initialSlide={0}
            pagination={{ clickable: true }}
            centeredSlides={true}
            spaceBetween={24}
            loop={true}
            autoplay={true}
            autoHeight={false}
            breakpoints={{
              576: {
                slidesPerView: 2,
                centeredSlides: false,
                loop: false,
              },
              769: {
                slidesPerView: 3,
                centeredSlides: false,
                loop: false,
              },
              1025: {
                slidesPerView: 4,
                centeredSlides: false,
                loop: false,
              },
            }}
          >
            {chooseCards}
          </Swiper>
        </div>

      </div>
    </section>
  );
};

export default SectionChoose;